<template>
  <div class="app-email-template">
    <v-container>
      <v-card>
        <v-card-title class="headline lighten-2" primary title>{{$t('truck_loaded_email_template.template')}}</v-card-title>
        <v-card-text>
          <v-textarea v-model="template" auto-grow></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="saveTemplate"
          >{{$t('truck_loaded_email_template.save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "app-email-template",
  props: ["user"],
  data() {
    return {
      template: this.user.company.truck_loaded_email_template,
    };
  },
  methods: {
      saveTemplate(){
          if(!this.template.includes('%orders')){
              alert(this.$t('truck_loaded_email_template.enter_orders_placement'))
              return 0;
          }
          this.user.company.save({
              truck_loaded_email_template: this.template
          });
      }
  }
};
</script>

<style scoped>
</style>